import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { formattedkW, formattedNumber } from '../../../../../utils/formatterHelpers';
import '../../../../../grid.css';
import './cappoints.css';

class CapPoints extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        setSelectedFinancing: PropTypes.func.isRequired,
        systemSize: PropTypes.number.isRequired,
        annualInflation: PropTypes.number.isRequired,
        taxRate: PropTypes.number.isRequired,
        capTerm: PropTypes.number.isRequired,
        capDownPayment: PropTypes.number.isRequired,
        resiToggle: PropTypes.bool.isRequired,
    };

    handleSelectPPA() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(1);
    }

    handleSelectLoan() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(2);
    }

    handleSelectOBS() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(3);
    }

    handleSelectCash() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(4);
    }

    handleSelectCAP() {
        const { setSelectedFinancing } = this.props;
        setSelectedFinancing(5);
    }


    render() {
        const {
            annualResults,
            annualInflation,
            systemSize,
            taxRate,
            capTerm,
            resiToggle,
            capDownPayment,
        } = this.props;

        const kW = formattedkW(systemSize / 1000);
        const totalLeasePayment = annualResults[1].annualCAPPayment * capTerm / 12;


        return (
            <Paper className="row capPoints">
                <div className="col span-1-of-3">
                    <ul className="align">
                        <li>
                        Term:&nbsp;{capTerm} months
                        </li>
                        <li>
                        Total Incentives:
                        ${formattedNumber(annualResults[30].cumulativeTotalAnnualIncentives)}
                        </li>
                        <li>
                        Avoided Utility Cost:
                        ${formattedNumber(annualResults[30].cumulativeSolarSavings)}
                        </li>
                        <li>
                        Lifetime Production:&nbsp;
                            {formattedNumber(annualResults[30].cumulativeSystemProduction)} kWh
                        </li>
                    </ul>
                </div>
                <div className="col span-1-of-3">
                    <ul className="align">
                        <li> System Size: {kW} kW</li>
                        <li>Utility Inflation: {annualInflation} %</li>
                        {resiToggle ? null : <li>Tax Rate: {taxRate} %</li> }
                    </ul>
                </div>
                <div className="col span-1-of-3 ">
                    <ul className="align">
                        <li>
                            Upfront Payment:
                            ${formattedNumber(capDownPayment)}
                        </li>
                        <li>
                            Lease Payment:
                            ${formattedNumber(annualResults[1].annualCAPPayment)}
                        </li>
                        <li> Total Lease Payments: ${formattedNumber(totalLeasePayment)}</li>
                        <li>Cash In Hand End Year 1:
                            ${formattedNumber(annualResults[1].cumulativeCAPSavings)}
                        </li>
                    </ul>
                </div>
            </Paper>
        );
    }
}

export default CapPoints;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CapPoints/CapPoints.js